// Dynamic configuration loader - fetches config from API endpoint
let cachedConfig = null;

const CONFIG_ENDPOINT = process.env.REACT_APP_CONFIG_ENDPOINT;

export async function loadAwsConfig() {
    if (cachedConfig) {
        return cachedConfig;
    }

    // If no config endpoint is set, use fallback immediately (local development)
    if (!CONFIG_ENDPOINT) {
        console.log('No CONFIG_ENDPOINT set, using local development config');
        cachedConfig = {
            Auth: {
                Cognito: {
                    region: 'eu-central-1',
                    userPoolId: 'eu-central-1_sX3OCUelB',
                    userPoolClientId: '4ia2f4nuvci01ad0r1t5b206r7'
                }
            }
        };
        return cachedConfig;
    }

    try {
        const response = await fetch(CONFIG_ENDPOINT);
        const contentType = response.headers.get('content-type');
        if (!response.ok || !contentType || !contentType.includes('application/json')) {
            throw new Error(`Failed to fetch config: status=${response.status}, content-type=${contentType}`);
        }
        const config = await response.json();
        
        cachedConfig = {
            Auth: {
                Cognito: {
                    region: config.region,
                    userPoolId: config.userPoolId,
                    userPoolClientId: config.userPoolClientId,
                    loginWith: {
                        oauth: {
                            domain: config.cognitoDomain || 'vatservices-prod-144553827356.auth.eu-central-1.amazoncognito.com',
                            scopes: ['email', 'openid', 'profile'],
                            redirectSignIn: [window.location.origin],
                            redirectSignOut: [window.location.origin],
                            responseType: 'code'
                        }
                    }
                }
            },
            API: {
                REST: {
                    vatservicesapi: {
                        endpoint:'https://4gmri80hb8.execute-api.eu-central-1.amazonaws.com/prod',
                        region: config.region || 'eu-central-1'
                    }
                }
            }
        };
        
        return cachedConfig;
    } catch (error) {
        console.error('Error loading AWS config:', error);
        // Fallback for local development
        cachedConfig = {
            Auth: {
                Cognito: {
                    region: 'eu-central-1',
                    userPoolId: 'eu-central-1_sX3OCUelB',
                    userPoolClientId: '4ia2f4nuvci01ad0r1t5b206r7'
                }
            }
        };
        return cachedConfig;
    }
}

// For backward compatibility - will be populated after loadAwsConfig() is called
const awsconfig = {
    Auth: {
        Cognito: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_sX3OCUelB',
            userPoolClientId: '4ia2f4nuvci01ad0r1t5b206r7'
        }
    }
};

export default awsconfig;
